import foto1 from "./1.png";
import foto2 from "./2.png";

const obj = {
  foto1,
  foto2,
};

export default obj;
